module.exports = __webpack_public_path__ + "img/icon-clock-active.4bf9f2ed.svg";